import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';

@Component({
    selector: 'yeehro-single-media-player',
    templateUrl: './single-media-player.component.html',
    styleUrls: ['./single-media-player.component.scss'],
    standalone: false
})
export class SingleMediaPlayerComponent implements OnInit {
  @Input() videoDetails;
  @Input() enableTimeSlider?: boolean = false;
  @Output() videoCompleted = new EventEmitter();

  preload: string = 'auto';
  api: VgApiService;

  // vgProperties: 
  //  - current: How long have they watched so far
  //  - left: How much time is left

  constructor() { }

  ngOnInit(): void {
    // console.log('videoDetails: ', this.videoDetails);
  }


  onPlayerReady(api: VgApiService) {
    this.api = api;

    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
        this.videoCompleted.next(null);
      }
    );
  }
}